import React from "react";
import { Form, Field } from "react-final-form";

const unlockForm = (props) => (
  <Form
    onSubmit={props.screenUnlock}
    render={({ handleSubmit, submitting, pristine, values }) => (
      <form autoComplete="off" onSubmit={handleSubmit}>
        <div className="input-group">
          <Field
            type="password"
            name="password"
            className="form-control"
            component="input"
            autoComplete="off"
            placeholder="Enter password"
            required
          />
          <span className="input-group-append">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={submitting || pristine}
            >
              <i className="icon md-lock-open" aria-hidden="true"></i>
              <span className="sr-only">unLock</span>
            </button>
          </span>
        </div>
        {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
      </form>
    )}
  />
);

export default unlockForm;
